import React from 'react'

const Navbar = () => {
  return (
    <>
     <div className="navbar bg-dark   mx-auto rounded-top-3" style={{position:"sticky",top:0}}>
        <div className='navbar-brand text-light mx-auto' ><i className=' fa fa-mobile-android' ></i> Contact <span className='text-warning' >Manager</span></div>
      
     </div> 
    </>
  )
}

export default Navbar
